// extracted by mini-css-extract-plugin
export default {"root":"LanguageList-module--root--e4338","archiveTitle":"LanguageList-module--archiveTitle--fed32"};